import { motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { fetchConfig } from "@/lib/api";
import Logo from "@/components/Logo";

export function FinalCta() {
  const { data: config } = useQuery({ queryKey: ["config"], queryFn: fetchConfig, staleTime: 300_000 });
  const vipUrl = config?.whop?.vip_checkout_url || "#pricing";
  const freeUrl = config?.whop?.free_checkout_url || "#pricing";

  return (
    <section className="relative overflow-hidden border-t border-[#1E2738]" data-testid="final-cta-section">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,rgba(0,230,118,0.1),transparent_60%)]" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-4 py-12 text-center sm:px-6 sm:py-28 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.5 }}
          className="flex flex-col items-center"
        >
          <Logo compact />
          <h2 className="mt-6 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl">
            Ready To Start<br />Printing<span className="text-[#00E676]">?</span>
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-400">
            Join Money Printer for NBA picks, analysis, transparent tracking and the community.
            No false guarantees. No hidden losses.
          </p>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
            <a href={vipUrl} target={vipUrl.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" data-testid="final-join-vip-btn" className="btn-primary">
              Join VIP <ArrowRight size={16} />
            </a>
            <a href={freeUrl} target={freeUrl.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" data-testid="final-free-picks-btn" className="btn-outline">
              Get Free Picks
            </a>
          </div>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-wider text-slate-600">
            18+ · Gamble responsibly · Gambling Help Online 1800 858 858 · No outcome is ever guaranteed
          </p>
        </motion.div>
      </div>
    </section>
  );
}

export default FinalCta;
